var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.CurrentTab,{tag:"component",attrs:{"menu-feature":_vm.childMenuFeature},scopedSlots:_vm._u([{key:"tabs",fn:function(){return [_c('ListTab',{attrs:{"tabs":_vm.tabs,"current-tab":_vm.CurrentTab},on:{"change-tab":_vm.ChangeTab}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }